import React from 'react';

interface EmptyStateCardProps {
  title: string;
  message: string;
  className?: string;
}

const EmptyStateCard: React.FC<EmptyStateCardProps> = ({ title, message, className = '' }) => (
  <div className={`py-8 w-full ${className}`}>
    <div className="card rounded-lg shadow w-full p-6 md:p-8 bg-gray-50 dark:bg-gray-800/50">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <img
          src="/files/images/predictorpro-des.png"
          alt="Predictor Pro Presenter"
          className="w-44 md:w-48 h-auto mx-auto md:mx-0 flex-shrink-0 md:mr-12"
        />
        <div className="text-center md:text-left md:flex-1 md:pr-6">
          <h3 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
            {title}
          </h3>
          <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
            {message}
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default EmptyStateCard;
